import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from '../../utils/BaseIcon';

const SearchSystemIcon = props => {
  const iconFill = 'currentColor';
  return (
    <BaseIcon {...props}>
      <g fill="none" fillRule="evenodd"><path d="M0 0h24v24H0z"/><path fill={iconFill} fillRule="nonzero" d="M5.995.828c4.973-2.113 10.718.205 12.832 5.178a9.784 9.784 0 01-1.575 10.197l6.495 6.495a.75.75 0 01-1.06 1.06l-6.495-6.495a9.78 9.78 0 01-2.543 1.575C8.676 20.952 2.931 18.634.817 13.66-1.296 8.687 1.022 2.942 5.995.828zm11.452 5.765a8.284 8.284 0 10-1.784 9.118l.017-.02a8.281 8.281 0 001.767-9.097z"/></g>
    </BaseIcon>
  );
};

SearchSystemIcon.displayName = 'SearchSystemIcon';

SearchSystemIcon.propTypes = {
  theme: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]), PropTypes.number]),
  fill: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
}

SearchSystemIcon.defaultProps = {
  size: 24
};

SearchSystemIcon.displayName = 'SearchSystemIcon';
SearchSystemIcon.iconName = 'Search';

export default SearchSystemIcon;
